<div class="float-end">
    <a href="javascript:void(0);" (click)='addNewTopic()' style="color:black; font-size: 14px;"> <i class="fa fa-plus fa-xs"></i> Add new Topics</a>
</div>